import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import img65 from '../EquipoMedico/img65.jpg'

export class Neonatology extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Neonatology</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Mantenemos el estándar de ancho lg={8} para que la imagen sea protagonista 
                        y la información sea fácil de leer sin perder calidad */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img65} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', 
                                            maxHeight: '900px', 
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Neonatal and Delivery Room Equipment
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}